import React from "react";
import { Image } from "react-native";
import CommonStyles from "../../../../../Diathrive/src/utils/CommonStyles";
import { tID } from "../../../../../Diathrive/src/utils/TestIdHelper";
import { Images } from "../../../utils/Images";
import LogoHeader from "../../elements/LogoHeader";
import MobileAppStoreLinks from "../../elements/MobileAppStoreLinks";
import styles from "./styles";

const UniqueIdContainer = ({ children, testIdScreenName = "" }) => (
  <div
    data-testid={tID(
      `${testIdScreenName ? testIdScreenName + "-" : ""}div-Container`
    )}
    style={styles.container}
  >
    <div style={styles.uniqueIdForm}>
      <LogoHeader />
      <div style={styles.formContainer}>{children}</div>
      <MobileAppStoreLinks
        containerStyle={CommonStyles.mb_52}
        testIdScreenName={testIdScreenName}
      />
    </div>
    <Image
      source={Images.signup}
      style={styles.previewImage}
      resizeMode="stretch"
    />
  </div>
);

export default UniqueIdContainer;
